import { hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { dasherize } from '@ember/string';
import Component from '@glimmer/component';

import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { eq, or } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';
import { lookupTranslation } from 'umg-ember-backend/utils/intl';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class RecordExplorerTableTh extends Component {
  // Services
  @service intl;

  // Sorting
  get isSorted() {
    return this.args.column.property === this.args.activeSort?.replace('-', '');
  }

  get isAsc() {
    return this.isSorted && this.args.activeSort[0] !== '-';
  }

  get label() {
    const lookups = [
      `tables.${this.args.recordType}`,
      'tables.defaults',
      `forms.${this.args.recordType}`,
      'forms.defaults',
    ];

    return lookupTranslation.call(this, lookups, {
      append: `fields.${this.args.column.property}`,
    });
  }

  get sort() {
    if (!this.args.column.sortable || !this.isSorted) {
      return null;
    }

    if (this.isAsc) {
      return 'asc';
    }

    return 'desc';
  }

  get sortIcon() {
    if (this.sort === 'asc') {
      return 'sort-ascending';
    }

    if (this.sort === 'desc') {
      return 'sort-descending';
    }

    return 'sort';
  }

  // Functions
  updateSort = () => {
    if (this.args.column.sortable && this.args.onUpdateSort) {
      let property = this.args.column.property;

      let sort = this.isAsc ? `-${property}` : property;

      this.args.onUpdateSort(sort);
    }
  };

  // Template
  <template>
    <th
      class={{bem
        (hash
          property=(dasherize (or @column.property ''))
          is-sortable=@column.sortable
          is-main-column=@column.isMainColumn
          sort=this.sort
        )
      }}
      data-test-table-th
      data-test-table-th-is-sortable={{@column.sortable}}
      data-test-table-th-property={{@column.property}}
      data-test-table-th-sort={{this.sort}}
      role='button'
      {{on 'click' this.updateSort}}
    >
      {{#unless (eq @column.type 'row-actions')}}
        {{this.label}}
      {{/unless}}

      {{#if @column.sortable}}
        {{svgJar
          this.sortIcon
          class=(bem 'sort' (hash direction=this.sort))
          data-test-table-th-sort-icon=this.sortIcon
        }}
      {{/if}}
    </th>
  </template>
}
